import {
  SanctionedScreeningForm,
  ScreeningSuccessModal,
} from '@paywithextend/components'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  selectPostingUserScreenErrorDetailMapFromState,
  selectPostingUserScreenFromState,
  selectPostingUserScreenTopLevelErrorFromState,
  selectScreeningStatusFromState,
  selectVirtualCard,
  selectVirtualCardIdFromRoute,
} from 'src/app/ScreenVirtualCard/redux/screenVirtualCard.selectors'
import NotFoundPopupContent from 'src/components/NotFoundPopupContent/NotFoundPopupContent'
import Popup from 'src/components/Popup/Popup'
import { useFlyoutDispatch } from 'src/hooks'
import { getLocaleInfo } from 'src/localization/locales'
import { ScreeningStatus } from 'src/models/virtualCard.models'
import { closeModal } from 'src/navigation/Lnk'
import { getCountrys } from 'src/redux/actions/data/countrys.actions'
import { postUserScreen } from 'src/redux/actions/data/users.actions'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import {
  selectCountryListModelsFromState,
  selectCountryOptions,
} from 'src/redux/selectors/data/countrys.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { PostUserScreenRequest } from 'src/requests/postUserScreen.request'

const ScreenVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const appName = useSelector(selectAppName)
  const countryOptions = useSelector(selectCountryOptions)
  const countrysMap = useSelector(selectCountryListModelsFromState)
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCard)
  const locale = useSelector(selectNullSafeLocaleFromState)

  useEffect((): void => {
    dispatch(getCountrys())
  }, [])

  useEffect((): void => {
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCard?.status, virtualCardId])

  const onScreeningFormSubmit = (
    body: Omit<PostUserScreenRequest, 'virtualCardId'>,
  ): void => {
    const splitBirthday = body.birthday?.split('/')
    dispatch(
      postUserScreen(
        {
          ...body,
          birthday: splitBirthday
            ? getLocaleInfo(locale).dateString(splitBirthday)
            : undefined,
          virtualCardId: virtualCard?.id,
        },
        virtualCardId,
      ),
    )
  }
  const postingUserScreen = useSelector(selectPostingUserScreenFromState)
  const postingUserScreenTopLevelError = useSelector(
    selectPostingUserScreenTopLevelErrorFromState,
  )
  const postingUserScreenErrorDetailMap = useSelector(
    selectPostingUserScreenErrorDetailMapFromState,
  )
  const screeningStatus = useSelector(selectScreeningStatusFromState)
  const closeScreeningSuccessModal = (): void => {
    dispatch(closeModal())
  }

  return virtualCard !== undefined && virtualCard.issuer !== undefined ? (
    screeningStatus !== ScreeningStatus.Pass &&
    virtualCard.screeningRequired &&
    virtualCard.screening?.status === ScreeningStatus.NeedsMoreInfo ? (
      <SanctionedScreeningForm
        appName={<>{appName}</>}
        issuerName={virtualCard?.issuer?.name}
        onSubmit={onScreeningFormSubmit}
        countryOptions={countryOptions}
        countrysMap={countrysMap}
        isLoading={postingUserScreen}
        topLevelError={postingUserScreenTopLevelError}
        errorDetailMap={postingUserScreenErrorDetailMap}
      />
    ) : screeningStatus === ScreeningStatus.Pass ? (
      <ScreeningSuccessModal
        onClick={closeScreeningSuccessModal}
        appName={appName}
      />
    ) : null
  ) : (
    <Popup>
      <NotFoundPopupContent></NotFoundPopupContent>
    </Popup>
  )
}

export default ScreenVirtualCard
